import { styled } from '@mui/system';
import { Box } from '@mui/material';
import { SectionHeading } from '../../../../../ui/typography';

export const SectionWrapper = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 16px',
  },
}));

export const GridContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  alignItems: 'center',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '5fr 7fr',
    gap: '45px',
    maxWidth: '1100px',
    margin: '0 auto',
  },
}));

export const LeftColumn = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  [theme.breakpoints.up('md')]: {
    height: '100%',
    alignItems: 'flex-start',
  },
  [theme.breakpoints.down('md')]: {
    margin: '0 auto 50px',
  },
}));

export const SessionTitle = styled(SectionHeading)(({ theme }) => ({
  ...theme.typography.heading,
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    textAlign: 'left',
    fontSize: '50px',
    lineHeight: '58px',
    minWidth: '450px',
    letterSpacing: '-0.9px',
  },
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  height: '60px',
  maxWidth: '275px',
  justifyContent: 'center',
  margin: '50px auto 0 0',
  [theme.breakpoints.up('md')]: {
    justifyContent: 'flex-start',
    marginTop: '45px',
  },
}));

export const RightColumn = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

export const SessionItemsContainer = styled('div')(({ theme }) => ({
  gap: '14px',
  display: 'flex',
  flexDirection: 'column',
}));
